import { inject } from '@angular/core';
import { BaseStoreFacade } from '@city/data-access';
import { StrapiGetListParameters } from '@core/const';
import { parametersWithCityFilterFactory } from '@core/utils';
import { Observable, switchMap, take } from 'rxjs';
import { StrapiCollectionEntityApiService } from './collection-entity-api.service';

export abstract class StrapiCollectionEntityByCityApiService<
  TAttributes extends object,
> extends StrapiCollectionEntityApiService<TAttributes> {
  private baseStoreFacade: BaseStoreFacade = inject(BaseStoreFacade);

  constructor(
    entityName: string,
    private fieldNameCityIncluded: keyof TAttributes,
    private fieldNameCityExcluded?: keyof TAttributes,
  ) {
    super(entityName);
  }

  getListByCity(
    parameters: StrapiGetListParameters<TAttributes>,
    baseStoreCode: string,
  ): Observable<Array<{ id: number } & TAttributes>> {
    return this.baseStoreFacade.getBaseStoresCodes().pipe(
      take(1),
      switchMap((allBaseStoreCodes) =>
        super.getList({
          ...parameters,
          ...parametersWithCityFilterFactory<TAttributes>({
            fieldNameCityIncluded: this.fieldNameCityIncluded,
            fieldNameCityExcluded: this.fieldNameCityExcluded,
            baseStoreCode,
            filters: parameters.filters,
            allBaseStoreCodes,
          }),
        }),
      ),
    );
  }

  // TODO: add create, update, delete methods
}
